function objectToGetParams(object) {
  const params = Object.keys(object).filter(key => !!object[key]);

  if (!params.length) {
    return '';
  }

  return `?${params
    .map(key => `${key}=${encodeURIComponent(object[key])}`)
    .join('&')}`;
}

const socialShareLinks = {
  facebook: params => {
    const { url, text = '', longtext = '' } = params;
    return `https://www.facebook.com/sharer/sharer.php${objectToGetParams({
      u: url,
      quote: `${text} ${longtext}`,
    })}`;
  },
  twitter: params => {
    const { url, text = '' } = params;
    return `https://twitter.com/share${objectToGetParams({
      url,
      text,
    })}`;
  },
  linkedin: params => {
    const { url, text = '', longtext = '' } = params;
    return `https://www.linkedin.com/shareArticle${objectToGetParams({
      url,
      title: text,
      summary: longtext,
    })}`;
  },
  whatsapp: params => {
    const { url, text = '', longtext = '' } = params;
    return `https://wa.me/${objectToGetParams({
      text: `${text} ${longtext} ${url}`,
    })}`;
  },
};

export default function generateShareLinks(params) {
  const { platform, ...rest } = params;
  const key = platform.toLowerCase();

  return socialShareLinks[key](rest);
}
